import {IBrandingArea,IPrintAreas, IProductJSONFromHTML} from "./type";
import {images} from "../../assets/images";
import {initialisePopupFunctions, tabController, initUploadLogoButton, getFontData} from "./util";
import {addTextHTMLHandler} from "../productDetail/textCustomisationBox";
import {textEditorInitial} from "./productConfigurationController";
import {
    CanvasEditor,
    deleteSelectedObjects,
    alignToolsBtn,
    backToOdooApp,
    initCanvas
} from "./components";
import { qtyProxy } from "../../..";
import "@melloware/coloris/dist/coloris.css";
import { appendElementWithId, checkToLoadScriptFoOdoo, getFetchEditProductJsonUrl, setLoader, transformData } from "../../helpers/helper";
import { errorMessages, LIST_LIMIT } from "../../assets/config";
import { addPositionOptionsHandler, initializeCanvasesForPositions } from "./util/printPositionDropDownController";
import { fetchLogoLibraryList, renderLogoListHTML } from "./util/logoLibraryController";
import { addTextToCanvasHandler } from "../productDetail/textController";
import { editCanvasInit } from "./util/editCanvasCartController";
import { fetchEditProductJson } from "../../../src/helpers/apiHelper";


/**
 * Generates a product configuration string.
 *
 * @param {any} result - The result data used to generate the configuration. Could be the product's main data.
 * @param {boolean} [isEdit=false] - Flag to indicate if the configuration is in edit mode. Defaults to `false`.
 * @param {object} [dataForEdit={}] - An optional object containing additional data needed for edit mode.
 * @param {string} [dataForEdit.logoList] - An string that represents a list of logos, used when editing a product.
 * @param {string} [dataForEdit.canvasJson] - An string containing canvas data in JSON format, used for rendering or editing product designs.
 * 
 * @returns {string} - Returns a string representing the product configuration, including any modifications if in edit mode.
 */
export const ProductConfiguration = (result : IProductJSONFromHTML[],isEdit = false,dataForEdit: {logoList? : string, canvasJson?: string} = {}): string => {
    const printAreas : IPrintAreas = transformData(result);
    const product = printAreas?.[0]
    const defaultSelectedBranding: IBrandingArea = product?.brandingAreas?.[0];
    initializeCanvasesForPositions(printAreas);

    const initJSEvents = async () =>{
        tabController();
        if(isEdit) editCanvasInit(dataForEdit?.logoList);
        await initCanvas(defaultSelectedBranding,qtyProxy['selectedPositionIndex'],dataForEdit?.canvasJson);
        textEditorInitial();
        addTextToCanvasHandler();
        deleteSelectedObjects();
        initUploadLogoButton();
        initialisePopupFunctions();
        alignToolsBtn();
        backToOdooApp();
        addPositionOptionsHandler(printAreas,isEdit);
        await renderLogoListHTML();
        await fetchLogoLibraryList(1,LIST_LIMIT);
    }

    setTimeout(() => {
        initJSEvents();
    }, 100)

    return `    
        <section class="product-detail">
            <div class="product-builder-header">
                <div class="back-to-product"> 
                    <button type="button" id="BackToOdoo"> 
                        <figure class="back-to-product-icon"><img src="${images['Left_icon']}" alt="left_icon" /></figure>
                        <p>Back to Product </p>  
                    </button>
                </div>
                <div id="technic-title">Front, Digital Transfer</div>
                <div class="brand-options-change" id="branding-option-slider">
                    <p>Branding Options: <span id="show-current-position">0 / 0</span></p>
                    <div class="brand-option-buttons">
                       <button type="button" id="previous-position" class="change-current-position prev-current-position"> 
                         <figure class="back-to-product-icon"><img src="${images['Left_icon']}" alt="left_icon" /></figure>
                       </button>
                       <button type="button" id="next-position" class="change-current-position next-current-position">
                         <figure class="back-to-product-icon"><img src="${images['Right_icon']}" alt="right_icon" /></figure>
                       </button>
                    </div>
                </div>
            </div>
            <section class="product-show">
             <div class="canvas-actions">
                             <button id="zoomIn" class="inputLabel label_space">
                                <img src="${images['Zoom_in.png']}" alt="${images['Zoom_in.png']}"  class="Zoom_img"/>
                                Zoom in
                             </button>
                             <button id="zoomOut" class="inputLabel">
                                <img src="${images['Zoom_out.png']}" alt="${images['Zoom_out.png']}" class="Zoom_img"/>
                                Zoom out
                             </button>
                             <button id="undo" class="inputLabel">
                                <img src="${images['Undo.png']}" alt="${images['Undo.png']}" class="Undo_img"/>
                                undo
                             </button>
                             <button id="redo" class="inputLabel">
                                <img src="${images['Redo.png']}" alt="${images['Redo.png']}" class="Redo_img"/>
                                redo
                             </button>
                        </div>
                <div class="right-side">
                    <div class="product-info-wrapper">
                            <button id="" class="inputLabel label_space">
                                <img src="${images['Back_arrow']}" alt="${images['Back_arrow']}"  class="back_button"/>
                            </button>
                        <div class="product-info">
                            <h2 class="product-name" id="headerProductName">${product?.brandingAreas[0]?.availableTechniques[0]?.name}</h2>
                            <p class="product-sku" id="headerProductSku">${product.sku}</p>
                        </div>
                    </div>
                    <div class="canvas-section">
                        ${CanvasEditor(printAreas)}
                      
                    </div>
                </div>
                <div class="left-side">
                    <div class="stepper-section">
                        <div class="custom-dropdown">
                             <img id="selection-dropdown-logo"  src="${images['Down_icon']}" alt="${images?.["Down_icon"]}" class="drop_down_arrow"/>
                             <select class="select-position-dropdown"  id="print-area-selection">
                             </select>
                             <div class="select-position-dropdown select-position-dropdown-edit" id="print-area-selection-edit">Front, Digital transfer (up to 9 cms)</div>
                        </div>
                        <div class="tabButtons">                     
                            <button class="step-button active" name="1">
                                <figure>
                                    <img id="logo_icon" src="${images['Logo_icon']}" alt="logo_icon" class="logo_icon"/>
                                </figure>
                                <p>Logo</p>
                            </button>
                            <button class="step-button" name="2">
                                <figure>
                                    <img id="text_icon" src="${images['Text_icon']}" alt="text_icon" class="text_icon"/>
                                </figure>
                                <p>Text</p>
                            </button>
                        </div>
                        <div id="1" class="tabView tabShow">
                          <div id="noteMessage" class="bg-warning hidden"></div>
                          <div class="uploadLogo" id="uploadLogoPopup">
                            <p class="font-bold upload_file_center">Upload file (optional)</p>
                            <button class="new-primary-btn" id="openLogoLibrary">Add</button>
                            <button class="new-secondary-btn delete-buttons" id="deleteButton">Delete</button>
                          </div>
                          <div class="summary-wrapper" id="logo-summary-wrapper">
                                <p>We accept: jpg, jpeg, png, .eps, .pdf or .ai file types.</p>
                                <p>Maximum 10mb file size.</p>
                          </div>
                          <div id="colorContainer" class="hidden">
                          </div>
                        </div>
                        <div id="2" class="tabView tabHide">
                          <div class="textInput">
                            <div class="text-add-title">
                                Your Text:  <input type="text" id="addedText"/>
                            </div>
                            <div class="text-buttons textInput">
                                <button id="applyText" class="new-primary-btn btn-sm">Add</button>
                                <button class="new-secondary-btn delete-buttons">Delete</button>
                            </div>
                          </div>
                          ${addTextHTMLHandler()}
                        </div>
                    </div>
                    <div class="stepper-actions">
                        <button id="openPreviewBtn" class="new-secondary-btn preview-btn">
                           <p> Preview </p>
                           <figure>
                                    <img id="text_icon" src="${images['Preview_icon']}" alt="preview_icon" class="text_icon"/>
                            </figure>
                        </button>
                        <button id="nextStepButton" class="new-secondary-btn confirm-btn">
                            <p>Confirm </p>
                            <figure>
                                    <img id="text_icon" src="${images['Confirm_icon']}" alt="confirm_icon" class="text_icon"/>
                            </figure>
                        </button>
                        <button id="saveButton" class="hidden">Save</button>
                    </div>
                </div>
            </section>
        </section>
    `
}


/**  
 We get data from the data-products-json attribute for first time add, and for the edit we fetch the required data from API. In below function we pass that data to integrate inside our html using ProductConfiguration function.
**/
const renderProductToolHelper = async() =>{
    if (checkToLoadScriptFoOdoo()) {
        return;
    }
    try{
        setLoader(true);
        await getFontData();
        const rootElement = document.getElementById("jasani_product_builder");
        const productJson = rootElement?.getAttribute("data-products-json");
        const odooBaseUrl = rootElement?.getAttribute("data-url");
        if(!productJson || !rootElement) return;
        const isEdit = rootElement?.getAttribute("data-isEdit")?.toLocaleLowerCase() === "true";
        if(isEdit && productJson){
            const editId = JSON.parse(productJson)?.[0]?.edit_json
            const productEditData = await fetchEditProductJson(getFetchEditProductJsonUrl(odooBaseUrl,editId));
            if(!productEditData){
                setLoader(false);
                alert(errorMessages.SERVER_ERROR);
                return;
            }
            qtyProxy['productEditData'] = JSON.stringify(productEditData);
            appendElementWithId("content", ProductConfiguration([{...productEditData}],true,{canvasJson :JSON.stringify(productEditData?.jsonForEdit) , logoList : JSON.stringify(productEditData?.editLogoList)}));
            return;
        }
        appendElementWithId("content", ProductConfiguration(JSON.parse(productJson)));
    }catch(error) {
        setLoader(false);
        console.error(error);
        alert(errorMessages.SERVER_ERROR);
    }
}

renderProductToolHelper();
